module.exports = __webpack_public_path__ + "img/home-improvements.edefdc4e.png";